import React from 'react';

// Relatorios de resultados publicados. Para adicionar o proximo periodo:
//  1. Copie a apresentacao para public/apresentacoes/MMAAAA/ (index.html + email.html)
//  2. Adicione uma entrada no topo desta lista (mais recente primeiro).
//  3. Se houver versao executiva resumida, marque executivo: true (le index-executivo.html).
//  4. Se houver a versao reestruturada (cada assunto tratado uma unica vez), marque
//     executivoV2: true (le index-executivo-v2.html).
//  5. Se houver o deck de slides (navegacao horizontal), marque slides: true
//     (le index-slides.html).
const RELATORIOS = [
  {
    periodo: '06/2026',
    titulo: '1o Relatorio de Resultados de TI',
    resumo: 'O Centrao virou a chave: 20 sistemas proprios, 1.306 entregas de codigo e a operacao fora das planilhas.',
    pasta: '/apresentacoes/062026',
    executivo: true,
    executivoV2: true,
    slides: true,
  },
];

export default function Apresentacoes() {
  return (
    <div className="content-shell">
      <section className="page-header">
        <div>
          <span className="section-header__eyebrow">TI</span>
          <h1>Apresentacoes de Resultados</h1>
          <p>Relatorios executivos das entregas do time de Tecnologia. Cada periodo tem a apresentacao completa e a versao para e-mail.</p>
        </div>
      </section>

      {RELATORIOS.length ? (
        RELATORIOS.map((rel) => (
          <section className="content-card" key={rel.periodo}>
            <span className="section-header__eyebrow">{rel.periodo}</span>
            <h2>{rel.titulo}</h2>
            <p>{rel.resumo}</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '16px' }}>
              <a
                className="btn-portal btn-portal--outline"
                href={`${rel.pasta}/index.html`}
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-file-richtext" /> Versao completa
              </a>
              {rel.slides && (
                <a
                  className="btn-portal btn-portal--primary"
                  href={`${rel.pasta}/index-slides.html`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-easel2" /> Slides (9 telas)
                </a>
              )}
              {rel.executivoV2 && (
                <a
                  className="btn-portal btn-portal--outline"
                  href={`${rel.pasta}/index-executivo-v2.html`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-stars" /> Versao executiva (v2)
                </a>
              )}
              {rel.executivo && (
                <a
                  className="btn-portal btn-portal--outline"
                  href={`${rel.pasta}/index-executivo.html`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-file-earmark-text" /> Versao executiva (v1)
                </a>
              )}
              <a
                className="btn-portal btn-portal--outline"
                href={`${rel.pasta}/email.html`}
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-envelope" /> Ver e-mail
              </a>
            </div>
          </section>
        ))
      ) : (
        <div className="empty-state">
          <strong>Nenhuma apresentacao publicada</strong>
          <span>Os relatorios de resultados da TI aparecerao aqui.</span>
        </div>
      )}
    </div>
  );
}
